import * as React from "react";
import { ComponentProps, useContext } from "react";

import { Button } from "affinityUI/elements/button";

import { InnerFormContext } from "../../controls/innerFormContext";

export const ExecuteButton: React.FC<ComponentProps<typeof Button>> = ({ children, disabled, ...props }) => {
  const { isBusy } = useContext(InnerFormContext) ?? {};
  const buttonDisabled = isBusy || disabled;
  return (
    <Button type="submit" disabled={buttonDisabled} {...props}>
      {children}
    </Button>
  );
};
